export const BOARD_GROUP_BY = (t, contentType) => {
  if (contentType === "TASK") {
    return [
      { value: "groupByFinishDate", label: "Finish Date" },
      {
        value: "assignees",
        label: t("Assigned to"),
      },
      {
        value: "groupByProgress",
        label: t("Progress"),
      },
      {
        value: "bucketId",
        label: t("Bucket"),
      },
    ];
  }
  if (contentType == "SALE") {
    return [
      {
        value: "bucketId",
        label: t("Funnel Stage"),
      },
      {
        value: "assignees",
        label: t("Assignees"),
      },
    ];
  }

  return [
    {
      value: "bucketId",
      label: t("Group"),
    },
  ];
};
